(function (h, o, u, n, d) {
    h = h[d] = h[d] || {
        q: [],
        onReady: function (c) {
            h.q.push(c);
        },
    };
    d = o.createElement(u);
    d.async = 1;
    d.src = n;
    n = o.getElementsByTagName(u)[0];
    n.parentNode.insertBefore(d, n);
})(
    window,
    document,
    'script',
    'https://www.datadoghq-browser-agent.com/us5/v6/datadog-rum.js',
    'DD_RUM'
);
window.DD_RUM.onReady(function () {
    window.DD_RUM.init({
        applicationId: '43a14c85-c5bf-4675-a31e-d9427fa04524',
        clientToken: 'pub8c6f4b66348571cf27bc3a128462f787',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'us5.datadoghq.com',
        service: 'freskincare',
        env: 'production',
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'allow',
    });
    const parsedData = JSON.parse(localStorage.getItem('context_data'));
    if (parsedData) {
        try {
            window.DD_RUM.setUserProperty('id', parsedData.userId);
        } catch (error) {
            console.error('Error parsing context_data from localStorage:', error);
        }
        try {
            window.DD_RUM.setGlobalContextProperty('pixel', parsedData);
        } catch (error) {
            console.error('Error setting global context property:', error);
        }
    }
});
